import { httpClient as http } from '@/utils/http'
import type {
  ApiResponse,
  PageResponse,
  BatchDeleteRequest,
  BatchUpdateValidDateRequest,
  BatchUpdateTimeRequest,
  BatchUpdatePriceRequest,
  IncreaseRulesPageRequest,
  IncreaseRulesListVO,
  IncreaseRulesVO,
  IncreaseRulesSaveRequest,
  IncreaseRulesUpdateRequest,
  PriceFclBatchDetailVO
} from './types'

// 分页查询加价规则
export const page = (params: IncreaseRulesPageRequest) => {
  return http.post<PageResponse<IncreaseRulesListVO>>('/price/increase-rules/page', params)
}

// 新增加价规则
export const save = (params: IncreaseRulesSaveRequest) => {
  return http.post<boolean>('/price/increase-rules/save', params)
}

// 修改加价规则
export const update = (params: IncreaseRulesUpdateRequest) => {
  return http.post<boolean>('/price/increase-rules/update', params)
}

// 获取加价规则详情
export const get = (id: string) => {
  return http.post<ApiResponse<IncreaseRulesVO>>('/price/increase-rules/get', { id })
}

// 批量启用加价规则
export const batchOnline = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/increase-rules/batch-online', params)
}

// 批量停用加价规则
export const batchOffline = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/increase-rules/batch-offline', params)
}

// 批量修改有效期
export const batchUpdateValidDate = (params: BatchUpdateValidDateRequest) => {
  return http.post<boolean>('/price/increase-rules/batch-update-valid-date', params)
}

// 批量修改时间（统一接口）
export const batchUpdateTime = (params: BatchUpdateTimeRequest) => {
  return http.post<boolean>('/price/increase-rules/batch-update-time', params)
}

// 批量修改价格
export const batchUpdatePrice = (params: BatchUpdatePriceRequest) => {
  return http.post<boolean>('/price/increase-rules/batch-update-price', params)
}

// 批量删除加价规则
export const batchDelete = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/increase-rules/batch-delete', params)
}

// 根据IDs查询加价规则明细（批量改价用）
export const getBatchPriceDetails = (params: BatchDeleteRequest) => {
  return http.post<ApiResponse<PriceFclBatchDetailVO[]>>('/price/increase-rules/batch-price-details', params)
}